import Swal from 'sweetalert2'
import { i18n } from './i18n'
import store from './store'

const $t = i18n.global.t

export default {
  swal () {
    return Swal.mixin({
      customClass: {
        closeButton: 'dialog-close',
        cancelButton: 'dialog-cancel',
        confirmButton: 'dialog-confirm'
      }
    })
  },

  confirmModal (confirmText, confirmButtonText, cancelButtonText, successAction) {
    Swal.fire({
      title: confirmText,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText
    })
      .then(result => {
        if (result.isConfirmed) {
          successAction()
        }
      })
  },

  notifyMessage (html,
    title = '',
    icon = '',
    showConfirmButton = false,
    confirmButtonText = '',
    showCancelButton = false,
    cancelButtonText = '') {
    this.swal().fire({
      title,
      html,
      icon,
      showConfirmButton,
      showCancelButton,
      confirmButtonText,
      cancelButtonText
    })
  },

  notifySuccessMessage (message,
    showConfirmButton = true,
    confirmButtonText = $t('default.close')) {
    this.notifyMessage(message, '', 'success', showConfirmButton, confirmButtonText)
  },

  notifyErrorMessage (error,
    showConfirmButton = true,
    confirmButtonText = $t('default.close')) {
    if (error.response && error.response.data && error.response.data.message) {
      const message = error.response.data.message

      if (message === 'validation_errors') {
        const text = []
        for (const key in error.response.data.data) {
          const errorData = error.response.data.data[key]
          text.push(errorData.join('<br/>'))
        }

        this.notifyMessage(text.join('<br/>'), '', 'warning', showConfirmButton, confirmButtonText)
      } else {
        this.notifyMessage(message, '', 'error', showConfirmButton, confirmButtonText)
      }
    } else if (typeof error === 'string' || error instanceof String) {
      this.notifyMessage(error, '', 'error', showConfirmButton, confirmButtonText)
    } else {
      this.notifyMessage($t('default.errors.general'), '', 'error', showConfirmButton, confirmButtonText)
    }
  },

  notifyWarningMessage (error,
    showConfirmButton = false,
    confirmButtonText = '') {
    if (error.response && error.response.data && error.response.data.message) {
      const message = error.response.data.message

      if (message === 'validation_errors') {
        const text = []
        for (const key in error.response.data.data) {
          const errorData = error.response.data.data[key]
          text.push(errorData.join('<br/>'))
        }

        this.notifyMessage(text.join('<br/>'), '', 'warning', showConfirmButton, confirmButtonText)
      } else {
        this.notifyMessage(message, '', 'warning', showConfirmButton, confirmButtonText)
      }
    } else if (typeof error === 'string' || error instanceof String) {
      this.notifyMessage(error, '', 'warning', showConfirmButton, confirmButtonText)
    } else {
      this.notifyMessage($t('errors.general'), '', 'error', showConfirmButton, confirmButtonText)
    }
  },

  getLocalizedFieldName (object, labelKa) {
    if (i18n.global.locale === 'en' && object[`${labelKa}_eng`] && object[`${labelKa}_eng`] !== '') return `${labelKa}_eng`

    if (i18n.global.locale === 'en' && object[`${labelKa}eng`] && object[`${labelKa}eng`] !== '') return `${labelKa}eng`

    if (i18n.global.locale === 'en' && object[`${labelKa}Eng`] && object[`${labelKa}Eng`] !== '') return `${labelKa}Eng`

    return labelKa
  },

  getLocalizedField (object, labelKa, labelEn) {
    if (i18n.global.locale === 'en' && labelEn && object[labelEn] !== '') return object[labelEn]

    return object[this.getLocalizedFieldName(object, labelKa)]
  },

  pagePermissions (link) {
    return store.getters['navigation/permissions'].find(o => o.link_new === link)
  },

  hasPermission (link, permission) {
    const permissions = this.pagePermissions(link)
    if (!permissions) return true

    return permissions.permissions.indexOf(permission) > -1
  },

  tableToExcel (tableID, filename = '') {
    // const uri = 'data:application/vnd.ms-excel;base64,'
    // const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
    // const base64 = function (s) {
    //  // console.log(window.btoa(encodeURI(encodeURIComponent(s))))
    //   return window.btoa(encodeURIComponent(s))
    // }
    // const format = function (s, c) {
    //   return s.replace(/{(\w+)}/g, function (m, p) {
    //     return c[p]
    //   })
    // }

    // if (!table.nodeType) table = document.getElementById(table)
    // const ctx = {
    //   worksheet: name || 'Worksheet',
    //   table: table.innerHTML
    // }
     
    // const link = document.createElement('a')
    // link.href = uri + base64(format(template, ctx))
   
    // link.setAttribute('download', 'export.xlsx')
    // document.body.appendChild(link)
    // link.click()


    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    
    // Specify file name
    filename = filename?filename+'.xls':'excel_data.xls';
    
    // Create download link element
    downloadLink = document.createElement("a");
    
    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob){
        var blob = new Blob(['\ufeff', tableHTML], {
            type: dataType
        });
        navigator.msSaveOrOpenBlob( blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }








  },

  appendTokenToUrl (url) {
    const token = store.getters['auth/token']

    url = url.indexOf('?') > -1 ? url + '&token=' + token : url + '?token=' + token

    return url
  }
}
